import { h } from 'preact';
import Swatches from './swatches';
import ColorSelector from './color-selector';
import TextInput from './text-input';
import Placements from './placements';

const Motifs = ({
  configuration,
  customizerSwatchesData,
  customizerMotifsData,
  state,
  activeTab,
  dispatch,
}) => {
  const { style } = activeTab;
  if (typeof configuration === 'string') {
    // eslint-disable-next-line no-param-reassign
    configuration = JSON.parse(configuration);
  }
  const currentMotifConfig = configuration.find(
    (curr) => curr.style.label === style,
  );
  const { optionalFonts } = currentMotifConfig;
  const { blocks } = customizerMotifsData.data;
  const {
    text_details: motifOptionalTextDetails,
    font_text_details: motifOptionalFontTextDetails,
    label,
  } = customizerSwatchesData.data.motifs;

  const motifsToRender = blocks.filter(
    (block) =>
      block.type === 'swatch-image' &&
      block.image !== '' &&
      configuration.map((c) => c.style.label).includes(block.title),
  );

  const handleMotifClick = ({ title }) => {
    const clickedMotifBlock = blocks.find((curr) => curr.title === title);
    const clickedMotifConfig = configuration.find(
      (curr) => curr.style.label === title,
    );

    const isDefaultPlacement = (placement) =>
      placement.label === defaultPlacement.label &&
      placement.horizontal === defaultPlacement.horizontal &&
      placement.vertical === defaultPlacement.vertical;

    const currentState = state[state.activeTab];

    const hasMatchingPlacement =
      currentState.placement &&
      clickedMotifConfig.placements?.some(
        (placement) =>
          placement.name === currentState.placement.name &&
          placement.horizontal === currentState.placement.horizontal &&
          placement.vertical === currentState.placement.vertical &&
          placement.scale === currentState.placement.scale,
      );

    let placement;
    if (isDefaultPlacement(currentState) || !hasMatchingPlacement) {
      placement = clickedMotifConfig.placements?.[0] || {
        ...defaultPlacement,
        horizontal: clickedMotifConfig.style.horizontal,
        vertical: clickedMotifConfig.style.vertical,
      };
    } else {
      placement = currentState.placement;
    }

    const payload = {
      ...state[state.activeTab],
      style: title,
      motifImage: clickedMotifBlock.image,
      placement,
    };

    dispatch({
      type: 'change_motif',
      payload,
    });
  };

  const handlePlacementChange = (placement) => {
    dispatch({
      type: 'change_motif',
      payload: {
        ...state[state.activeTab],
        placement,
      },
    });
  };

  const defaultPlacement = {
    label: state.metafieldData?.placement || 'Standard',
    horizontal: currentMotifConfig.style.horizontal,
    vertical: currentMotifConfig.style.vertical,
    scale: currentMotifConfig.style?.scale,
  };

  const { placements = [defaultPlacement] } = currentMotifConfig;

  const shouldRenderFontSelectorGroup = !!optionalFonts?.length;

  if (shouldRenderFontSelectorGroup) {
    const { blocks: customizerSwatchesBlocks } = customizerSwatchesData.data;
    const sectionDataColors = customizerSwatchesBlocks.filter(
      (block) => block.type === 'swatch-color' && block.color !== '',
    );
    const colorsToRender = sectionDataColors.filter((block) =>
      currentMotifConfig.colors.includes(block.title),
    );
    const {
      text,
      color,
      optionalFont: currentOptionalFont,
      textMaxLength,
      textMinLength,
    } = activeTab;

    const inputChangeHandler = ({ value }) => {
      dispatch({
        type: 'change_motif',
        payload: {
          ...state[state.activeTab],
          text: value.replace(/[^a-zA-Z]+/g, ''),
        },
      });
    };

    const handleColorClick = ({ title, hex }) => {
      dispatch({
        type: 'change_motif',
        payload: {
          ...state[state.activeTab],
          color: title,
          colorHex: hex,
        },
      });
    };

    const namesToRender = optionalFonts.map((font) => (
      <div
        // eslint-disable-next-line max-len
        className={`border border-1 hover:border-gray-900 text-center h-10 transition-all cursor-pointer text-xs flex items-center justify-center ${
          font === currentOptionalFont ? 'border-gray-900' : 'border-gray-400'
        }`}
        style={{
          fontFamily: font,
          fontSize: font === 'Handwritten' ? 5 : 12,
        }}
        key={`${font}`}
        onClick={() => {
          dispatch({
            type: 'change_motif',
            payload: {
              ...state[state.activeTab],
              optionalFont: font,
            },
          });
        }}
      >
        {font}
      </div>
    ));

    return (
      <div className="border border-1 border-x-0 border-t-0 border-gray-300 pb-5 mb-5">
        <Placements
          placements={placements}
          currentPlacement={state[state.activeTab].placement}
          defaultPlacement={defaultPlacement}
          onChangeHandler={handlePlacementChange}
        />
        <Swatches
          swatchesToRender={motifsToRender}
          clickHandler={handleMotifClick}
          currentStyle={style}
          label={label}
          monogramTextDetails={motifOptionalTextDetails}
        />
        <div className="border border-1 border-x-0 border-t-0 border-gray-300 pb-5 mb-5">
          <div className="body-3 mb-2.5">
            Font: <span className="font-medium">{currentOptionalFont}</span>
          </div>
          <div className="grid grid-cols-5 gap-2 mb-3.5">{namesToRender}</div>
          {motifOptionalFontTextDetails && (
            <p className="body-3 text-color-subdued">
              {motifOptionalFontTextDetails}
            </p>
          )}
        </div>
        <ColorSelector
          colorsToRender={colorsToRender}
          clickHandler={handleColorClick}
          currentColor={color}
          overlayImage={customizerSwatchesData.data.monograms.image}
        />
        <TextInput
          currentText={text}
          textMaxLength={textMaxLength}
          textMinLength={textMinLength}
          changeHandler={inputChangeHandler}
        />
      </div>
    );
  }

  return (
    <div className="border border-1 border-x-0 border-t-0 border-gray-300 pb-5 mb-5">
      <Placements
        placements={placements}
        currentPlacement={state[state.activeTab].placement}
        onChangeHandler={handlePlacementChange}
      />
      <Swatches
        swatchesToRender={motifsToRender}
        clickHandler={handleMotifClick}
        currentStyle={style}
        label={label}
      />
    </div>
  );
};

export default Motifs;
